import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Typography from '@mui/material/Typography';
import ProjectCard from "../../PortfolioSection/ProjectCard/ProjectCard";
import { portfolioData } from "../../PortfolioSection/Portfolio/portfolioData";
import './ProjectPage.scss';
import ProjectModal from "../../PortfolioSection/ProjectModal/ProjectModal";
import ProjectFilter from "../ProjectFilter/ProjectFilter";
import { motion } from "framer-motion"
import Footer from "../../Footer/Footer";
import Masonry from '@mui/lab/Masonry';
import Card from "../../PortfolioSection/ProjectCard/Card";

const ProjectPage = () => {
    
    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    const [ isModalOpen, toggleModal ] = React.useState(false);
    const [ modalContent, setModalContent ] = React.useState({
        title:'',
        image:'',
        brief:'',
        description:[],
        code:'',
        demo:'',
        tech:[]
    });

    const openModal = () => {
        toggleModal(true);
    }

    const closeModal = () => {
        toggleModal(false);
    }

    const setModalData = (project) => {
        setModalContent(project);
    }

    const [ projects, setProjects ] = React.useState(portfolioData);
    const [ filter, setFilter ] = React.useState('all');

    React.useEffect(() => {

        const filteredProjects = portfolioData.filter((project) => (
            project.filter.includes(filter) || filter==='all'
        ));

        setProjects(filteredProjects);

    }, [filter]);

    return (
        <div id="project-page">

            <div className="nav">
                <div className="container">
                    <Typography variant="h3" gutterBottom component="div" className="navbar-brand">
                        <span className="initial">A</span>nshika <span className="initial">A</span>grawal
                    </Typography>
                </div>
            </div>

            <div className="container">

                <Typography variant="h3" gutterBottom component="div" className="text-center main-heading">
                    Portfolio
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center mini-heading">
                    Projects I have build
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center sub-heading">
                    Do show some <span className="star">&#9825;</span> and drop in <span className="star">&#9734;</span>
                </Typography>

                <ProjectModal 
                    modalContent={modalContent}
                    closeModal={closeModal}
                    isModalOpen={isModalOpen}
                 />

                <ProjectFilter
                    filter={filter}
                    setFilter={setFilter}
                 />

                <motion.div layout className="project-boxes">
                {/* <Masonry columns={3} spacing={2}> */}
                    {
                        projects.map((project, index) => (
                            <motion.div
                                key={index}
                                layout
                                animate={{opacity:1}}
                                initial={{opacity:0}}
                                exit={{opacity:0}}
                            >
                                <div 
                                    data-aos="fade-up" 
                                    data-aos-delay={50*(index+1)}
                                    data-aos-duration="900"
                                    data-aos-easing="ease-in-out"
                                >
                                    {/* <ProjectCard 
                                        project={project}
                                        openModal={openModal}
                                        setModalData={setModalData}
                                    /> */}
                                    <Card 
                                        project={project}
                                        openModal={openModal}
                                        setModalData={setModalData}
                                    />
                                </div>
                            </motion.div>
                        ))
                    }
                    {/* </Masonry> */}
                </motion.div>

            </div>

            <Footer link="https://github.com/AnshikaAgrawal5501" />
        </div>
    );
}

export default ProjectPage;